<div
  class="irx-sobre-oscuro"
  style="position: relative; width: 100%; height: 100%; display: flex"
>
  <video
    #videoEl
    autoplay
    muted
    playsinline
    style="width: 100%; height: 100%; display: block; object-fit: contain; background: #000"
  ></video>

  @if (loading) {
    <div
      style="
        position: absolute;
        inset: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.35);
      "
    >
      <mat-spinner diameter="40"></mat-spinner>
    </div>
  }

  @if (errorMsg) {
    <div
      style="
        position: absolute;
        inset: 0;
        display: flex;
        flex-direction: column;
        gap: 8px;
        align-items: center;
        justify-content: center;
        background: rgba(0, 0, 0, 0.6);
        color: #fff;
        padding: 12px;
        text-align: center;
      "
    >
      <mat-icon>error</mat-icon>
      <span>{{ errorMsg }}</span>
      @if (retryInSecs !== null) {
        <span style="font-size: 0.85em; opacity: 0.75">
          Reintentando en {{ retryInSecs }} s…
        </span>
      }
      @if (puedeReintentar) {
        <button irxBoton="secundario" (click)="reintentar()">
          <mat-icon>refresh</mat-icon>
          Reintentar
        </button>
      }
    </div>
  }

  @if (botonMultiple) {
    @if (maximizado) {
      <button
        irxBotonIcono="imagen"
        class="custom-btn"
        tooltip="Ver todas las cámaras"
        (click)="botonClick()"
      >
        <mat-icon>apps</mat-icon>
      </button>
    } @else {
      <button
        irxBotonIcono="imagen"
        class="custom-btn"
        tooltip="Ampliar"
        (click)="botonClick()"
      >
        <mat-icon>fullscreen</mat-icon>
      </button>
    }
  }

  @if (maximizado && idCamara) {
    <button
      irxBotonIcono="imagen"
      class="ptz-toggle-btn"
      (click)="togglePTZ()"
      alternable
      [activo]="ptzVisible"
      [disabled]="!ptzSupported"
      [tooltip]="ptzSupported ? 'Control PTZ' : 'PTZ no soportado'"
    >
      <mat-icon>control_camera</mat-icon>
    </button>

    @if (ptzVisible) {
      <div class="ptz-overlay">
        <div class="ptz-dpad">
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(4)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 4)"
            (touchend)="stopPTZ()"
            tooltip="Arriba izquierda"
          >
            <mat-icon>north_west</mat-icon>
          </button>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(0)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 0)"
            (touchend)="stopPTZ()"
            tooltip="Arriba"
          >
            <mat-icon>arrow_upward</mat-icon>
          </button>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(6)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 6)"
            (touchend)="stopPTZ()"
            tooltip="Arriba derecha"
          >
            <mat-icon>north_east</mat-icon>
          </button>

          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(2)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 2)"
            (touchend)="stopPTZ()"
            tooltip="Izquierda"
          >
            <mat-icon>arrow_back</mat-icon>
          </button>
          <div class="ptz-center"><mat-icon>videocam</mat-icon></div>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(3)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 3)"
            (touchend)="stopPTZ()"
            tooltip="Derecha"
          >
            <mat-icon>arrow_forward</mat-icon>
          </button>

          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(5)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 5)"
            (touchend)="stopPTZ()"
            tooltip="Abajo izquierda"
          >
            <mat-icon>south_west</mat-icon>
          </button>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(1)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 1)"
            (touchend)="stopPTZ()"
            tooltip="Abajo"
          >
            <mat-icon>arrow_downward</mat-icon>
          </button>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(7)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 7)"
            (touchend)="stopPTZ()"
            tooltip="Abajo derecha"
          >
            <mat-icon>south_east</mat-icon>
          </button>
        </div>

        <div class="ptz-zoom">
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(8)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 8)"
            (touchend)="stopPTZ()"
            tooltip="Zoom in"
          >
            <mat-icon>zoom_in</mat-icon>
          </button>
          <button
            irxBotonIcono="imagen"
            class="ptz-btn"
            [disabled]="ptzBusy"
            (mousedown)="startPTZ(9)"
            (mouseup)="stopPTZ()"
            (mouseleave)="stopPTZ()"
            (touchstart)="onPtzTouchStart($event, 9)"
            (touchend)="stopPTZ()"
            tooltip="Zoom out"
          >
            <mat-icon>zoom_out</mat-icon>
          </button>
        </div>
      </div>
    }
  }
</div>
